export default __webpack_public_path__ + "static/media/bigrestaurant_mobile.395f34b2.jpg";